import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'
import Card from 'app/frontend/base/components/Card'
import { useCopyToClipboard } from 'app/frontend/base/helpers/hooks'
import { Check, CopyIcon } from 'lucide-react'
import { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  copyValue?: string
  title: string
  className?: string
}

const ApplicationInfoBlock = ({
  copyValue,
  title,
  children,
  className,
}: PropsWithChildren<Props>) => {
  const { t } = useTranslation()
  const { copied, copyToClipboard } = useCopyToClipboard()

  return (
    <Card className={'min-w-0'}>
      <div className='text-sm text-muted-foreground mb-1 flex justify-between items-center'>
        <span>{title}</span>
        {copyValue ? (
          <>
            {copied ? (
              <span className='ml-2 text-success-foreground flex gap-1 items-center'>
                <Check size={14} />
              </span>
            ) : (
              <Tooltip>
                <TooltipTrigger>
                  <CopyIcon
                    size={12}
                    className='cursor-pointer'
                    onClick={() => copyToClipboard(copyValue)}
                  />
                </TooltipTrigger>
                <TooltipContent>
                  {t(`dashboard.team.settings.click-to-copy`)}
                </TooltipContent>
              </Tooltip>
            )}
          </>
        ) : null}
      </div>

      <div className={cn('font-semibold', className)}>{children}</div>
    </Card>
  )
}

export default ApplicationInfoBlock
